import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { DateHelper } from 'src/app/helpers/date-helper';
import { CalendarConfiguration } from '../../../../../models/configuration/widgets/properties/controls/calendar/calendar-configuration';
import { ValidatableInputControlBase } from '../../input-controls/validatable-input-control-base';
import { SiteSettingsService } from 'src/app/services/deprecated/site-settings.service';

@Component({
    selector: 'fw-form-edit-calendar',
    templateUrl: './form-edit-calendar.component.html',
    host: { 'class': 'form-field' }
})
export class FormEditCalendarComponent extends ValidatableInputControlBase<Date> implements OnInit {

    @Input()
    public Calendar: CalendarConfiguration;

    constructor(
        protected transloco: TranslocoService,
        private siteSettingsService: SiteSettingsService
    ) {
        super(transloco);
    }

    public get dateFormat(): string {
        return this.siteSettingsService.dateFormat;
    }

    ngOnInit(): void {
        if (this.Calendar) {
            this.ConfigureDateTimeValidation(this.Calendar.Validation);
        }
    }

    public mapDateFormat(dateFormat: string): string {
        return DateHelper.mapCalendarDateFormat(dateFormat);
    }
}
